import { countryCodesByAlpha3 } from "assets/country-codes/country-codes";
import Content, { ContentNS } from "content/content";
import { FC } from "react";

import Picker from "./Picker";

interface CountryCodePickerProps {
  id: string;
  label?: string;
  error: string | null;
  onChange: (value: string) => void;
  onFocus?: () => void;
  value?: string | null;
  disabled?: boolean;
  placeholder?: string;
}

const CountryCodePicker: FC<CountryCodePickerProps> = ({
  id,
  label,
  disabled,
  value,
  error,
  placeholder,
  onChange,
  onFocus,
}) => {
  const textCountry = (s: string) =>
    Content.shared.t(s, { ns: ContentNS.countryCodes });

  const countryCodes = Object.keys(countryCodesByAlpha3)
    .map((key) => [key.toUpperCase(), textCountry(key.toUpperCase())])
    .sort((a, b) => a[1].localeCompare(b[1]));

  const options = countryCodes.map(([code, name]) => (
    <option key={code} value={code}>
      {name}
    </option>
  ));

  return (
    <Picker
      id={id}
      label={label}
      value={value}
      options={options}
      disabled={disabled}
      onChange={onChange}
      placeholder={placeholder}
      flagCode={countryCodesByAlpha3[value || ""]?.alpha2}
      error={error}
      onFocus={onFocus}
    />
  );
};

export default CountryCodePicker;
